import { combineReducers } from 'redux'
import account from './account';
import gift from './gift';
import app from './app';
import user from './user';
import store from './store';
import content from './content';
import loadingSpinner from './loadingSpinner';
import ready from './ready';
import merchant from "./merchant";
import image from "./image";
import support from "./support";
import promotion from "./promotion";
import guestCheckout from "./guestCheckout";
import security from "./security";
import cart from "./cart";
import stripe from "./stripe";
import zelle from "./zelle";

const createRootReducer = (history) => combineReducers({
    account,
    security,
    guestCheckout,
    cart,
    app: app,
    gift: gift,
    user: user,
    store: store,
    loadingSpinner: loadingSpinner,
    content: content,
    ready: ready,
    merchant: merchant,
    image: image,
    support: support,
    promotion: promotion,
    stripe,
    zelle
});

export default createRootReducer
